import { useMethods } from "@craftjs/utils";
import React, { useEffect } from "react";
import { LayerMethods } from "./actions";
import { LayerManagerContext } from "./context";
import { LayerEventContextProvider } from "../events";
import { DefaultLayer } from "../layers";
import { useEditor } from "@craftjs/core";

export const LayerManagerProvider = ({ children, options }) => {
  // TODO: fix type
  const store = useMethods(LayerMethods, {
    layers: {},
    events: {
      selected: null,
      dragged: null,
      hovered: null,
    },
    options: {
      renderLayer: DefaultLayer,
      ...options,
    },
  });

  const { selected } = useEditor((state, query) => {
    // TODO: handle multiple selected elements
    const selected = query.getEvent("selected").first();

    return {
      selected: selected,
    };
  });

  function scrollIntoViewIfNeeded(target) {
    if (!target) {
      return;
    }

    target.scrollIntoView({
      behavior: "smooth",
      block: "center",
      inline: "center",
    });
  }

  useEffect(() => {
    setTimeout(() => {
      const dom = document?.querySelector(
        `[data-grigora-layer-id='${selected}']`,
      );

      scrollIntoViewIfNeeded(dom);
    }, 300);
  }, [selected]);

  return (
    <LayerManagerContext.Provider value={{ store }}>
      <LayerEventContextProvider>{children}</LayerEventContextProvider>
    </LayerManagerContext.Provider>
  );
};
